import {useCallback} from "react";
import {mySongsPageStore} from "../../../../modules/my-songs-page-store/mySongsPage.store";
import {navigate} from "../../../../../../services/navigation/navigation";
import {useLocation} from "react-router-dom";

export interface ISongsMobileFilterActionsLogic {
  handleDoneOnClick: () => void;
  handleResetOnClick: () => void;
}

/** This function is duplicated elsewhere voaw8ej098rj23 */
function getActiveTabFromLocationPath(locationPath: string): string {
  const parts = locationPath.split("/"); //should result in ["", "songs", "browse", ]
  let activeTab;
  if(parts.length >= 3){
    activeTab = parts[2];
  }
  return activeTab ?? 'home';
}

export const useSongsMobileFilterActionsLogic = (): ISongsMobileFilterActionsLogic => {
  const {pathname} = useLocation();
  const currentResultsPage = getActiveTabFromLocationPath(pathname);

  const handleDoneOnClick = useCallback(() => {
    navigate(`/songs/${currentResultsPage}`);
  }, [currentResultsPage]);

  return {
    handleDoneOnClick,
    handleResetOnClick: () => mySongsPageStore.resetFiltersKeepingTheActiveMenuTheSearchAndTheSelectedSong(),
  };
}
